<template>
  <b-card-actions
    title="Unpaid Leave"
    :amount="unpaidAmount"
    :currency="currency"
    :collapsed="true"
    action-collapse
  >
    <b-row>
      <b-col
        md="4"
        lg="4"
        xs="6"
        :class="{ 'disabled': payslip && payslip.status === 'finally_generated' }"
      >
        <div>
          <b-card-text class="mb-0">
            {{ typeStatus }}
          </b-card-text>

          <b-form-checkbox
            :checked="isManualSwitch"
            class="custom-control-primary"
            name="check-button"
            switch
            :disabled="payslip?.status === 'finally_generated'"
            @change="(newVal) => typeChange(newVal)"
          />
        </div>

        <h5
          class="text-capitalize"
          style="margin-top: 20px"
        >
          Edit Amount
        </h5>
        <template>
          <div>
            <b-form-input
              id="unpaid_amount_value"
              v-model="unpaidAmount"
              type="number"
              placeholder="Unpaid Leave Amount"
              :disabled="!isManualSwitch || payslip?.status === 'finally_generated'"
            />
          </div>
        </template>

        <template v-if="isManualSwitch">
          <h5
            id="unpaid_remarks"
            class="text-capitalize"
            style="margin-top: 20px"
          >
            Unpaid Leave Remarks<span class="text-danger">*</span>
          </h5>
          <template>
            <ValidationProvider
              v-slot="{ errors }"
              name="remarks"
              vid="remarks"
              :rules="isManualSwitch ? 'required': ''"
            >
              <b-form-textarea
                id="remarks"
                v-model="remarks"
                :state="errors && errors.length ? false : null"
                type="text"
                placeholder="Remarks"
                :disabled="payslip && payslip?.status === 'finally_generated'"
                rows="1"
              />
            </ValidationProvider>
          </template>
        </template>
      </b-col>

      <b-col
        v-if="isManualSwitch"
        md="4"
        lg="4"
        xs="5"
      />

      <b-col
        v-else
        md="4"
        lg="4"
        xs="5"
      >
        <template>
          <h5 class="text-capitalize">
            Unpaid Leave Days Count: {{ payslip?.unpaid_leave_day_count }}
          </h5>
        </template>
      </b-col>

      <b-col
        offset="1"
        md="3"
        lg="3"
        xs="6"
      >
        <h5 class="text-capitalize">
          Unpaid Leave Fine Amount
        </h5>
        <template>
          <div>
            <b-form-input
              id="unpaid_amount_value"
              v-model="unpaidAmount"
              type="number"
              placeholder=""
              :disabled="true"
            />
          </div>
        </template>
      </b-col>
    </b-row>

  </b-card-actions>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {
  BCardText, BCol, BFormCheckbox, BFormInput, BFormTextarea, BRow,
} from 'bootstrap-vue'
import {
  required,
  email,
  max,
  mimes,
  ext,
  size,
  confirmed,
} from '@validations'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'UnpaidLeaveInfo',
  components: {
    ValidationProvider,
    BCardText,
    BFormTextarea,
    BFormCheckbox,
    BRow,
    BCol,
    BFormInput,
    BCardActions,
  },
  props: {
    payslip: {
      type: Object,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      unpaidAmount: 0,
      typeStatus: 'Manual',
      isManualSwitch: false,
      remarks: '',
    }
  },
  watch: {
    payslip: {
      handler() {
        this.setUnpaidLeaveAmount()
      },
      immediate: true,
    },
    remarks: {
      handler() {
        this.emitValue()
      },
      immediate: true, // Optional — add only if you want `emitValue()` called on component mount
    },
    isManualSwitch: {
      handler() {
        this.emitValue()
      },
      immediate: true, // Optional
    },
    unpaidAmount: {
      handler(newVal) {
        this.overTimeSalaryAmount = newVal
        this.emitValue()
      },
      immediate: true, // Optional
    },
  },

  methods: {
    emitValue() {
      this.$emit('append-remarks-data', this.remarks)
      this.$emit('append-isManual-data', this.isManualSwitch)
      this.$emit('append-manual-data', this.unpaidAmount)
    },
    setUnpaidLeaveAmount() {
      this.unpaidAmount = this.payslip?.unpaid_leave_fine_amount || 0
      this.remarks = this.payslip?.unpaid_leave_remarks

      if (this.remarks) {
        this.isManualSwitch = true
      }
    },
    typeChange() {
      this.isManualSwitch = !this.isManualSwitch
      if (this.isManualSwitch) {
        this.unpaidAmount = this.payslip?.unpaid_leave_fine_amount || 0
      }
    },
  },
}
</script>

<style scoped>
</style>
